import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import ProductEditor from './product-editor';
import { activeProductImageSelector, fullScreenModeSelector } from './connect/related-product.selector';
const mapStateToProps = createStructuredSelector({
  productImage: activeProductImageSelector,
  isFullScreenMode: fullScreenModeSelector
});
export default connect(mapStateToProps, null)(ProductEditor);